"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldWrapper = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const InputLabel_1 = __importDefault(require("@material-ui/core/InputLabel"));
const FormHelperText_1 = __importDefault(require("@material-ui/core/FormHelperText"));
const form_field_wrapper_styles_1 = require("./form-field-wrapper-styles");
const context_help_1 = require("../../../../components/context-help/context-help");
const react_intl_1 = require("react-intl");
const help_context_1 = require("../../../../common/help/help-context");
function FormFieldWrapper({ children, label, helpLabel = ' ', required, disabled, labelOptions, layoutOptions, errorOptions, before, after, errors, }) {
    var _a, _b, _c;
    const { underline, spacing, labelText, labelRoot, labelDisabled, labelError, boxRoot, boxError, labelBold, labelItalic, } = form_field_wrapper_styles_1.useStyles();
    const intl = react_intl_1.useIntl();
    const { formContextHelpType } = react_1.useContext(help_context_1.HelpContext);
    if (required) {
        const requiredText = intl.formatMessage({
            id: 'EAS_FIELD_REQUIRED',
            defaultMessage: 'Povinné pole',
        });
        if (helpLabel === ' ') {
            helpLabel = requiredText;
        }
        else {
            helpLabel = requiredText + '<br/>' + helpLabel;
        }
    }
    const hideLabel = (_a = labelOptions.hide) !== null && _a !== void 0 ? _a : false;
    const hideErrors = (_b = errorOptions.hide) !== null && _b !== void 0 ? _b : false;
    const hasError = ((_c = errors === null || errors === void 0 ? void 0 : errors.length) !== null && _c !== void 0 ? _c : 0) > 0;
    return (react_1.default.createElement(Grid_1.default, { item: true, xs: 12, classes: { root: clsx_1.default({ [underline]: !(layoutOptions === null || layoutOptions === void 0 ? void 0 : layoutOptions.noUnderline) }) } },
        react_1.default.createElement(Grid_1.default, { container: true, spacing: 0, alignItems: "flex-start", classes: { root: clsx_1.default({ [spacing]: !(layoutOptions === null || layoutOptions === void 0 ? void 0 : layoutOptions.noSpacing) }) } }, !hideLabel ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 4 },
                react_1.default.createElement(Box_1.default, { className: clsx_1.default(boxRoot, { [boxError]: hasError }) },
                    react_1.default.createElement(InputLabel_1.default, { disabled: disabled, classes: {
                            root: labelRoot,
                            disabled: labelDisabled,
                        } },
                        react_1.default.createElement(Typography_1.default, { variant: "body2", component: "div", classes: {
                                root: clsx_1.default(labelText, {
                                    [labelBold]: required || labelOptions.bold,
                                    [labelError]: hasError,
                                    [labelItalic]: labelOptions.italic,
                                }),
                            } }, label)),
                    react_1.default.createElement(context_help_1.ContextHelp, { type: formContextHelpType, label: helpLabel }))),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 8 },
                react_1.default.createElement(Box_1.default, { display: "flex" },
                    before,
                    children,
                    after),
                !hideErrors && (errors === null || errors === void 0 ? void 0 : errors.map((error, index) => {
                    const [key, defaultMessage] = error.value.split(';;');
                    return (react_1.default.createElement(FormHelperText_1.default, { key: index, error: hasError },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: key, defaultMessage: defaultMessage })));
                }))))) : (react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 12 },
            react_1.default.createElement(Box_1.default, { display: "flex" },
                before,
                children,
                after),
            !hideErrors && (errors === null || errors === void 0 ? void 0 : errors.map((error, index) => {
                const [key, defaultMessage] = error.value.split(';;');
                return (react_1.default.createElement(FormHelperText_1.default, { key: index, error: hasError },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: key, defaultMessage: defaultMessage })));
            })))))));
}
exports.FormFieldWrapper = FormFieldWrapper;
//# sourceMappingURL=form-field-wraper.js.map